/*
Item: Start page
Name: Dashboard
Format: Frontend component, partial screen
*/

import React, { Component } from 'react';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import PropTypes from 'prop-types';
import MessageService from '../service/MessageService';
import { MultiLanguage } from '../utils/MultiLanguage';
import News from '../components/News';

export default class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      statisticsList: [],
      objNews: [],
      loadingList: true,
    };
    this.messageService = new MessageService();
    this.multiLanguage = new MultiLanguage();
  }

  // onLoad read current data
  componentDidMount = async () => {
    this.loadStatisticList();
  };

  async handleClick(i) {
    const { statisticsList } = this.state;
    const { history } = this.props;
    history.push(`./tablesstandard&${statisticsList[i].name}`);
  }

  async loadStatisticList() {
    const statisticsList = await this.messageService.postStatisticDirectory();
    const type = 'statistic';
    const path = 'properties';
    const obj = {
      kriterium: ['name'],
      object: '19',
      objectType: 'STATISTIC',
    };
    const objNews = [];
    for (let i = 0; i < statisticsList.length; i += 1) {
      const id = statisticsList[i].name;
      const propertiesSuccess = await this.messageService.postRuleProperties(path, type, name, id, obj);
      if (!propertiesSuccess[1]) {
        const { entrys } = propertiesSuccess.data.contents.['genesis.container.content.GenesisTMContent'].transfermodel;
        if (entrys.length > 0) {
          const { explanation } = entrys[0];
          const { shortDescription } = entrys[0];
          const body = (this.multiLanguage.returnLanguage(explanation, 'de'));
          const subTitle = this.multiLanguage.returnLanguage(shortDescription, 'de');
          const bodyLine = {
            subTitle,
            body,
          };
          if (body !== null) {
            objNews.push(bodyLine);
          }
        }
      }
    }
    this.setState({
      statisticsList,
      loadingList: false,
      objNews,
    });
  }

  linkClick(address) {
    const { history } = this.props;
    history.push(`./${address}`);
  }

  renderMetaDataContent(statisticsList) {
    const { loadingList } = this.state;
    if (statisticsList) {
      return (!loadingList
        && (statisticsList.length === 0 || statisticsList[1] === 'info') ? (
          <div>
            <Panel style={{ backgroundColor: '#F44336', color: 'white' }}>
              Es konnten keine Statistiken geladen werden.
            </Panel>
          </div>
        )
        : (
          <div>
            <div>
              <div className="p-grid dashboard">
                {statisticsList.map((s, i) => (
                  <div
                    id={s.name}
                    tabIndex={i + 1}
                    role="button"
                    key={i}
                    className="p-col-12 p-md-4"
                    onClick={() => this.handleClick(i)}
                    onKeyDown={() => this.handleClick}
                  >
                    <div className="overview-box overview-box-4">
                      <div className="overview-box-header" />
                      <div className="overview-box-content">
                        <div className="overview-box-icon"><i className="material-icons">assessment</i></div>
                        <div className="overview-box-title">{s.name}</div>
                        <div className="overview-box-count">{this.multiLanguage.returnInLanguage(s, 'de')}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )
      );
    }
    return (<div />);
  }

  render() {
    const { statisticsList, objNews } = this.state;
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-lg-8">
          <div style={{ height: '100%' }}>
            <div className="p-col">
              <div>
                <div className="p-grid dashboard">
                  <div
                    tabIndex={0}
                    role="button"
                    id="evaluation"
                    className="p-col-12 p-md-12"
                    onClick={() => this.linkClick('evaluation')}
                    onKeyDown={() => this.linkClick('evaluation')}
                  >
                    <div className="overview-box overview-box-2">
                      <div className="overview-box-header" />
                      <div className="overview-box-content">
                        <div className="overview-box-icon"><i className="material-icons">apps</i></div>
                        <div className="overview-box-title">Übergreifende und individuelle Auswertungen</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-col">
              <Card title="Standardtabellen">
                {this.renderMetaDataContent(statisticsList)}
              </Card>
            </div>
            <div className="p-col">
              <div>
                <div className="p-grid dashboard">
                  <div
                    tabIndex={100}
                    role="button"
                    id="nonmonetary"
                    className="p-col-12 p-md-6"
                    onClick={() => this.linkClick('keyfigures&nonmonetary')}
                    onKeyDown={() => this.linkClick('keyfigures&nonmonetary')}
                  >
                    <div className="overview-box overview-box-2">
                      <div className="overview-box-header" />
                      <div className="overview-box-content">
                        <div className="overview-box-icon"><i className="material-icons">panorama_fish_eye</i></div>
                        <div className="overview-box-title">Kennzahlen</div>
                        <div className="overview-box-count">Nicht-monetär</div>
                      </div>
                    </div>
                  </div>
                  <div
                    tabIndex={101}
                    role="button"
                    id="monetary"
                    className="p-col-12 p-md-6"
                    onClick={() => this.linkClick('keyfigures&monetary')}
                    onKeyDown={() => this.linkClick('keyfigures&monetary')}
                  >
                    <div className="overview-box overview-box-2">
                      <div className="overview-box-header" />
                      <div className="overview-box-content">
                        <div className="overview-box-icon"><i className="material-icons">euro_symbol</i></div>
                        <div className="overview-box-title">Kennzahlen</div>
                        <div className="overview-box-count">Monetär</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Card>
                Bei Fragen zur Anwendung, Durchführbarkeit von Auswertungen sowie den Daten wenden Sie sich gerne an:
                betrieb&#8209;auswertungsdatenbankhochschulstatistik@destatis.de
            </Card>
            </div>
          </div>
        </div>
        <div className="p-col-12 p-lg-4">
          <News
            objNews={objNews}
          />
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  history: PropTypes.instanceOf(Object),
};

Dashboard.defaultProps = {
  history: null,
};
